import { AxiosInstance, AxiosResponse } from 'axios';
import { Route } from 'vue-router';
import { ChildData } from '@/services/pfdod';

export enum StatusEnum {
  PREPARE = 'PREPARE',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESSS',
  ERROR = 'ERROR',
}

export enum CertificateType {
  FINANCE = 'finance',
  ACCOUNT = 'account',
  UNDEFINED = 'undefined',
}

export enum StatementEnum {
  STATEMENT = 'statement',
  CLOSE = 'close',
}

export interface PfdodCert {
  kid_id: string | number;
}

export interface ICertificate {
  $api: AxiosInstance;
  $config: any;
  currentChild: ChildData;
  errors: Array<any>;
  error: boolean;
  id: string;
  state: any;
  logoImg: string;
  onChangeChild: (id: string) => void;
  beforeDestroy: () => void;
  parseChildren: (id: string) => void;
  action: (childAction: string) => void;
  actionMakePdf: () => void;
  actionActivateCert: () => void;
  actionGetNominal: () => void;
  actionGetCert: () => void;
}

export { AxiosInstance, AxiosResponse, Route, ChildData };



// WEBPACK FOOTER //
// ./src/pages/profile/views/certificate/types.ts